import { render, staticRenderFns } from "./Chi_defaultSection.vue?vue&type=template&id=65631a6e&scoped=true"
import script from "./Chi_defaultSection.vue?vue&type=script&lang=ts"
export * from "./Chi_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./Chi_defaultSection.vue?vue&type=style&index=0&id=65631a6e&prod&lang=css"
import style1 from "./Chi_defaultSection.vue?vue&type=style&index=1&id=65631a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65631a6e",
  null
  
)

export default component.exports